/**
 * RouterActions
 */

import { Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '@app/store';
import { IAction, IOpenRouteOptions, ENTITY_TYPES } from '@shared/types';

export const ROUTER_NAVIGATION_END: string = 'ROUTER_NAVIGATION_END';
export const OPEN_ROUTE_ACTION: string = 'OPEN_ROUTE_ACTION';

/**
 * # RouterActions
 * Defines the class for creating router actions
 */

@Injectable()
export class RouterActions {
  public static navigationEndAction(
    uri: string,
    entityType: ENTITY_TYPES,
  ): IAction {
    return {
      type: ROUTER_NAVIGATION_END,
      payload: {
        uri,
        entityType,
      },
    };
  }

  public static updateLocationAction(
    route: string = '',
    options?: IOpenRouteOptions,
  ): IAction {
    return {
      type: OPEN_ROUTE_ACTION,
      payload: {
        options,
        uri: `/${route}`,
      },
    };
  }

  /**
   * Initialize the instance
   */
  public constructor(private ngRedux: NgRedux<IAppState>) {}

  /**
   * Dispatch action for updating location
   */
  public updateLocation(route: string, options?: object): void {
    this.ngRedux.dispatch(RouterActions.updateLocationAction(route, options));
  }

  /**
   * Dispatch navigationEnd action
   */
  public navigationEnd(uri: string, entityType: ENTITY_TYPES): void {
    this.ngRedux.dispatch(RouterActions.navigationEndAction(uri, entityType));
  }
}
